<ll-titulo>Nuevo Plan de Clase</ll-titulo>
<plan-clase-new
    *ngIf="asignaturaId"
    [asignaturaId]="asignaturaId"
    [tipoEvaluacion]="tipoInstrumento"
    [enableModelos]="enableModelos"
></plan-clase-new>
